import React from 'react';
import CheckCircle from '../../assets/img/check-circle.png';
import InfoIcon from '../../assets/img/kplus-info.svg';
import getCardFrameHeight from '../../helpers/getCardFrameHeight';

const fitCardFrame = ({ currentTarget: frame }) => {
  const doc = frame.contentDocument;
  if (!frame.hasAttribute('srcdoc') || !doc?.body) {
    return;
  }
  const fit = () => {
    if (doc.defaultView) {
      frame.style.height = `${getCardFrameHeight(doc)}px`;
    }
  };
  fit();
  doc.fonts?.ready.then(fit);
};

export default function VirtualCardReady({ retailerName, cardExpiresIn, cardFrameRef, onOrderCompleted }) {
  return (
    <section className="k-virtual-card-ready">
      <p className="k-virtual-card-ready__status">
        <img src={CheckCircle} alt="" />
        <span>Initial payment successful</span>
      </p>
      <h1>Your virtual card is ready!</h1>
      <p className="k-virtual-card-ready__text">
        Show this card to the store associate to complete your purchase at {retailerName}.
      </p>
      <p className="k-virtual-card-ready__text">Only use this card for your approved purchase at {retailerName}.</p>
      <iframe
        ref={cardFrameRef}
        className="k-virtual-card-ready__card fs-exclude"
        title="Katapult Pay virtual card"
        scrolling="no"
        onLoad={fitCardFrame}
      />
      <p className="k-virtual-card-ready__disclaimer">
        This card is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A., Inc.
      </p>
      <div className="k-virtual-card-ready__expiry">
        <img src={InfoIcon} alt="" />
        <p>
          This virtual card will expire in {cardExpiresIn}.
          <br />
          Use it before it expires, or you’ll need to rebuild your cart.
        </p>
      </div>
      <div className="k-submit">
        <button type="button" onClick={onOrderCompleted}>
          Order completed
        </button>
      </div>
    </section>
  );
}
